import { useNavigate } from "react-router-dom";
import { useAuth } from "../../services/AuthContext";

function LogoutButton() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return <button onClick={handleLogout}>Logga ut</button>;
}
export default LogoutButton;